// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__EfBXz","links":"Footer_links__xJ8g+"};